import React from "react";

export default function MobileUnsupported() {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
                width: "100vw",
                textAlign: "center",
                padding: "2rem",
                boxSizing: "border-box",
                backgroundColor: "#f5f5f5",
                fontFamily: "sans-serif",
            }}
        >
            <img
                src={process.env.PUBLIC_URL + "/logo.png"}
                alt=""
                style={{ width: 96, marginBottom: "1.5rem" }}
            />
            <h1 style={{ color: "#25408f", marginBottom: "1rem" }}>
                Desktop Required
            </h1>
            <p style={{ fontSize: "1.1rem", maxWidth: 480, color: "#333" }}>
                This application can only be used on a desktop or laptop
                computer. Mobile devices are not supported. Please access V8
                using a desktop browser to continue.
            </p>
        </div>
    );
}
